import * as Actions from '../../actions/billing/types';

const initialState = {
  loading: false,
  error: null,

  // get card
  getCardLoading: false,
  cardData: '',

  // add card
  addCardSuccess: '',

  // update card
  updateCardSuccess: '',
};

const billingReducer = (state = initialState, action) => {
  switch (action.type) {
    // Get Card
    case Actions.GET_CARD_REQUEST:
      return { ...state, getCardLoading: true };

    case Actions.GET_CARD_SUCCESS:
      return {
        ...state,
        getCardLoading: false,
        cardData: action.payload || '',
      };

    case Actions.GET_CARD_FAIL:
      return {
        ...state,
        getCardLoading: false,
        error: action.payload,
      };

    case Actions.CLEAR_GET_CARD_STATES:
      return {
        ...state,
        cardData: '',
        getCardLoading: false,
        error: null,
      };

    // Add Card
    case Actions.ADD_CARD_REQUEST:
      return { ...state, loading: true };

    case Actions.ADD_CARD_SUCCESS:
      return {
        ...state,
        loading: false,
        addCardSuccess:
          action.payload?.message || 'Card Information Added Successfully',
        cardData: action.payload?.data || '',
      };

    case Actions.ADD_CARD_FAIL:
      return { ...state, loading: false, error: action.payload };

    case Actions.CLEAR_ADD_CARD_STATE:
      return { ...state, loading: false, error: null, addCardSuccess: '' };

    // Update Card Status
    case Actions.UPDATE_CARD_REQUEST:
      return { ...state, loading: true };

    case Actions.UPDATE_CARD_SUCCESS:
      return {
        ...state,
        loading: false,
        updateCardSuccess:
          action.payload?.message || 'Card Updated Successfully',
        cardData: action.payload?.data || '',
      };

    case Actions.UPDATE_CARD_FAIL:
      return { ...state, loading: false, error: action.payload };

    case Actions.CLEAR_UPDATE_CARD_STATE:
      return { ...state, loading: false, error: null, updateCardSuccess: '' };

    default:
      return state;
  }
};

export default billingReducer;
